import * as $ from "jquery";
import React from "react";
import { render } from "react-dom";
import NewCartButton from "../widgets/cartbutton/NewCartButton";
import Heart from "../widgets/heart";
import PreorderButton from "../widgets/PreorderButton";

createSwiper("swiper-toplist");
createSwiper("swiper-coming");
createSwiper("swiper-ujdonsag", false);
createSwiper("swiper-ebooks");
createSwiper("swiper-audios");
createSwiper("swiper-ebooks-discount");
createSwiper("swiper-audios-discount");
createSwiper("swiper-bestsellers");

const heroSectionSelector = ".swiper-hero-section";
$(heroSectionSelector).on("init", (_, slick) => updateHeroSectionUi(0, slick.$slides));
$(heroSectionSelector).on("afterChange", (_, slick, active) =>
    updateHeroSectionUi(active, slick.$slides)
);

$(heroSectionSelector).slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: ".swiper-hero-button-prev",
    nextArrow: ".swiper-hero-button-next",
    centerMode: window.innerWidth < 1024,
});

function updateHeroSectionUi(active, slides) {
    if (!slides[active]) return;
    const slideData = slides[active].querySelector(".hero-section-item").dataset;
    document.querySelectorAll(".hero-category").forEach((el) => {
        if (slideData.category === "") return el.classList.add("d-none");

        el.classList.remove("d-none");
        if (slideData.category.toLowerCase() === "előjegyezhető") {
            el.style.backgroundColor = "#FACC14";
            el.href = "/konyvek?bongeszde=hamarosan";
        } else if (slideData.category.toLowerCase() === "újdonság") {
            el.style.backgroundColor = "#9E89E6";
            el.href = "/konyvek?bongeszde=ujdonsag";
        } else if (slideData.category.toLowerCase() === "akció") {
            el.style.backgroundColor = "#ff0173";
            el.href = "/akciok";
        } else {
            el.style.backgroundColor = "#FACC14";
            el.href = `/cimke/${slideData.categoryslug}`;
        };

        el.textContent = slideData.category;
    });

    const oldPrice = slideData.newPrice != 0 && slideData.newPrice ? slideData.price : null;
    const price = (slideData.newPrice && slideData.newPrice != 0 ? slideData.newPrice : slideData.price) ?? null;

    document.querySelectorAll(".hero-price-wrapper").forEach((el) => {
        if (slideData.price === "" || slideData.price === null || slideData.price === undefined)
            return el.classList.add("d-none");
        el.classList.remove("d-none");

        document.querySelectorAll(".hero-price").forEach((el) => el.textContent = window.Dibook.language.formatCurrency(price));
    });

    document.querySelectorAll(".hero-old-price").forEach((el) => {
        if (oldPrice === null) return el.classList.add("d-none");
        el.classList.remove("d-none");
        el.textContent = window.Dibook.language.formatCurrency(oldPrice);
    });

    [
        ...document.querySelectorAll(".hero-buy-btn .new-widget-cartbutton"), 
        ...document.querySelectorAll(".hero-buy-btn .new-widget-preorder-button")
    ].forEach((el) => {
        el.dataset.id = slideData.id;

        if(slideData.category == "Előjegyezhető")
            render(<PreorderButton elem={el} />, el)
        else
            render(<NewCartButton elem={el} />, el)
    });

    document.querySelectorAll(".hero-price-wrapper .widget-heart").forEach((el) => {
        el.dataset.id = slideData.id;

        render(<Heart elem={el} purple wishlist />, el)
    });

    document.querySelectorAll(".hero-buy-btn #hero-book-type").forEach((el) => {
        if(slideData.type.toString() == "1")
            el.src = "/images/icon/new-ebook-icon-2.svg";
        else
            el.src = "/images/icon/new-audio-icon-2.svg";
    });

    const release_date = new Date(slideData.releasedate ?? null);
    const month = release_date.getMonth()+1;
    const day = release_date.getDate();
    document.querySelectorAll(".hero-release-date").forEach((el) => {
        if(slideData.category == "Előjegyezhető")
            el.classList.remove("d-none");
        else
            el.classList.add("d-none");

        el.textContent = `kb. ${release_date.getFullYear()}-${month > 9 ? month : '0'+month}-${day > 9 ? day : '0'+day}`;
    });

    return slideData;
}
